export default {
  url: "https://www.youtube.com/embed/videoseries?si=O2giHH-yLdEm7-A7&amp;list=PLO42QXiTwUWw21jVCp8pBLcN654OZrFvK",
  title: "Get Justice, Get kulpa",
  params: {
    rel: 0,
    autoplay: 1
  }
};
